import { render } from "./webshops.vue?vue&type=template&id=ef792820&scoped=true"
import script from "./webshops.vue?vue&type=script&lang=js"
export * from "./webshops.vue?vue&type=script&lang=js"

import "./webshops.vue?vue&type=style&index=0&id=ef792820&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef792820"]])

export default __exports__